module.exports = __webpack_public_path__ + "img/FFOld.b3038c31.png";